import { BrowserRouter as Router, Routes, Route, Outlet, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from './lib/api';
import DashboardPage from './pages/DashboardPage';
import QuestionBankPage from './pages/QuestionBankPage';
import ImportsPage from './pages/ImportsPage';
import TriageQueuePage from './pages/TriageQueuePage';
import QuizListPage from './pages/QuizListPage';
import QuizFormPage from './pages/QuizFormPage';
import QuizDetailPage from './pages/QuizDetailPage';
import QuizExportPage from './pages/QuizExportPage';

export default function App() {
  const [health, setHealth] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.health().then(setHealth).catch(err => setError(String(err)));
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppLayout health={health} error={error} />}>
          <Route index element={<DashboardPage />} />
          <Route path="/bank" element={<QuestionBankPage />} />
          <Route path="/imports" element={<ImportsPage />} />
          <Route path="/triage" element={<TriageQueuePage />} />
        </Route>
        <Route path="/quizzes" element={<QuizListPage />} />
        <Route path="/quizzes/new" element={<QuizFormPage />} />
        <Route path="/quizzes/:id" element={<QuizDetailPage />} />
        <Route path="/quizzes/:id/edit" element={<QuizFormPage />} />
        <Route path="/quizzes/:id/export" element={<QuizExportPage />} />
      </Routes>
    </Router>
  );
}

function AppLayout({ health, error }) {
  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', padding: 24, maxWidth: 1800, width: '96vw', margin: '0 auto', color: 'white', background: '#0b1120', minHeight: '100vh' }}>
      <div style={{ marginBottom: 20 }}>
        <h1>Veterinary Question Bank</h1>
        <div style={{ color: '#94a3b8' }}>
          {health ? `API connected · ${health.app_env} mode` : error ? `API error: ${error}` : 'Connecting…'}
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <Link to="/" style={{ background: '#334155', color: 'white', border: 0, borderRadius: 8, padding: '10px 14px', cursor: 'pointer', textDecoration: 'none' }}>Dashboard</Link>
          <Link to="/imports" style={{ background: '#334155', color: 'white', border: 0, borderRadius: 8, padding: '10px 14px', cursor: 'pointer', textDecoration: 'none' }}>Imports</Link>
          <Link to="/triage" style={{ background: '#334155', color: 'white', border: 0, borderRadius: 8, padding: '10px 14px', cursor: 'pointer', textDecoration: 'none' }}>Triage</Link>
          <Link to="/bank" style={{ background: '#334155', color: 'white', border: 0, borderRadius: 8, padding: '10px 14px', cursor: 'pointer', textDecoration: 'none' }}>Question Bank</Link>
          <Link to="/quizzes" style={{ background: '#334155', color: 'white', border: 0, borderRadius: 8, padding: '10px 14px', cursor: 'pointer', textDecoration: 'none' }}>Quizzes</Link>
        </div>
      </div>
      <div style={{ position: 'relative', minHeight: 'calc(100vh - 200px)' }}>
        <Outlet />
      </div>
    </div>
  );
}


